import React, { useState, useEffect } from "react";
import ProfileUpload from "../ProfileUploader";
import placeholderImg from "@src/assets/Signup/profile.png";
import profileCamera from "@src/assets/profileCamera.svg";
import { useExpertInfoStore } from "@src/store/ExpertInfoStore"; // 조회용 store
import { uploadExpertProfileImage } from "@src/api/expert/expertApi";
import styled from "styled-components";
import { getDeviceType, transferToNative, WebAppBridge } from "@src/lib/WebAppBridge";

const UserInfoProfileUploadContainer: React.FC = () => {
    const { form, setPartialState, setProfileUrl, isEditing } = useExpertInfoStore();
    const currentImageUrl = form.profile || form.infos[0]?.file?.url || "";

    const [uploading, setUploading] = useState(false);
    const fileInputRef = React.useRef<HTMLInputElement>(null);

     useEffect(() => {
        if (getDeviceType() !== "android") return;

        WebAppBridge.onGetProfileImage = (imageUrl: string) => {
            setProfileUrl(imageUrl);
            setPartialState({
                profile: imageUrl,
                infos: [{ ...form.infos[0], file: { url: imageUrl } }],
            });
        };

        return () => {
            WebAppBridge.onGetProfileImage = undefined as any;
        };
    }, [form.infos, setPartialState, setProfileUrl]);

    const handleFileSelected = async (file: File) => {
        if (!isEditing) return;
        try {
            setUploading(true);
            const url = await uploadExpertProfileImage(file);
           setProfileUrl(url);
setPartialState({
    profile: url,
    infos: [{ ...form.infos[0], file: { url } }],
});
        } catch (e) {
            alert("이미지 업로드에 실패했습니다.");
        } finally {
            setUploading(false);
        }
    };

    const handleInputChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        const file = e.target.files?.[0];
        if (file) {
            handleFileSelected(file);
        }
    };

    const handleCameraClick = () => {
        if (!isEditing) return;

        if (getDeviceType() === "android") {
            transferToNative("", "onClickProfile");
            return;
        }

        fileInputRef.current?.click();
    };

    return (
        <ProfileUploadWrap>
            <ProfileUpload
                imageUrl={currentImageUrl}
                placeholderSrc={placeholderImg}
                readOnly={!isEditing}
                isUploading={uploading}
                onFileSelected={handleFileSelected}
                addLabel=""
                showCameraIcon={true}
            />
            {/* 숨겨진 파일 input */}
            <input type="file" accept="image/*" style={{ display: "none" }} ref={fileInputRef} onChange={handleInputChange} />
            {isEditing && (
                <CameraIconWrap onClick={handleCameraClick} style={{ cursor: "pointer" }}>
                    <img src={profileCamera} alt="프로필 변경" />
                </CameraIconWrap>
            )}
        </ProfileUploadWrap>
    );
};

export default UserInfoProfileUploadContainer;

const ProfileUploadWrap = styled.div`
    position: relative;
    display: inline-block;
`;

const CameraIconWrap = styled.div`
    position: absolute;
    right: 4px;
    bottom: 4px;
    width: 32px;
    height: 32px;
    background: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    z-index: 2;
    img {
        width: 20px;
        height: 20px;
    }
`;
